/*!
 * social-proof.js — Ürün "sosyal kanıt" etiketleri (Toserof)
 * "Bu ürünü X kişi ziyaret etti / X kişi sepetine ekledi" kalıpları.
 *
 * GÖSTERİM (2026-07-07): EMOJİSİZ + ANİMASYONLU. Tek satır; önce GÖRÜNTÜLENME
 * etiketi belirir, ~3 sn sonra yerini SEPETE-EKLENDİ etiketine bırakır (fade),
 * sonra döngüyle başa döner. (prefers-reduced-motion: tek statik satır.)
 *
 * KURAL (patron): değerler ALGORİTMİK + TUTARLI olmalı. Sayfa her yenilendiğinde
 * AYNI sayı çıkar (ürün kimliğine bağlı seeded-random). Gün bazında çok hafif
 * dalgalanır (gün içinde sabit). Gerçek ziyaret verisi TOPLANMAZ (yazma izni yok).
 *
 * Kullanım: HTML'de  <div class="toserof-sp" data-sp-id="{{ product.id }}"></div>
 * Kart için: aynı eleman .grid-product içindeyse otomatik KISA mod kullanılır.
 */
(function () {
  'use strict';

  /* ===================== AYARLAR (kolayca değiştirilebilir) ===================== */
  var CFG = {
    viewsMin: 80,          // ürün başına ziyaret alt sınırı
    viewsMax: 1200,        // üst sınır
    addRatioMin: 0.05,     // sepete ekleme oranı (ziyaretin %5'i)
    addRatioMax: 0.16,     // (ziyaretin %16'sı)
    addMin: 5,             // en az sepete ekleme
    dailyDriftPct: 0.10,   // günlük dalgalanma ±%10 (gün içinde sabit)
    selector: '[data-sp-id]',
    holdMs: 3000,          // her etiket ekranda kalma süresi (döngü)
    fadeMs: 450            // geçiş (fade) süresi
  };

  /* Görüntülenme kalıpları (EMOJİSİZ) — ürün başına biri deterministik seçilir */
  var VIEW_TEMPLATES = [
    function (v) { return v + ' kişi görüntüledi'; },
    function (v) { return v + ' kişi inceledi'; },
    function (v) { return 'Son 24 saatte ' + v + ' görüntülenme'; },
    function (v) { return 'Bu ürünü ' + v + ' kişi görüntüledi'; },
    function (v) { return v + ' kişi inceledi'; }
  ];
  /* Sepete-ekleme kalıpları (EMOJİSİZ) — görüntülenme ile aynı index eşleşir */
  var ADD_TEMPLATES = [
    function (a) { return a + ' kişi sepete ekledi'; },
    function (a) { return a + ' kişi sepetine ekledi'; },
    function (a) { return 'Şu an ' + a + ' kişinin sepetinde'; },
    function (a) { return a + ' kişi sepete ekledi'; },
    function (a) { return a + ' kişi sepetine ekledi'; }
  ];

  /* Kart (koleksiyon) için kısa kalıp */
  function compactView(v) { return v + ' görüntülenme'; }
  function compactAdd(a) { return a + ' sepette'; }

  /* ===================== Deterministik hash + PRNG ===================== */
  function hashStr(str) {
    var h = 2166136261 >>> 0; // FNV-1a
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }
  function mulberry32(seed) {
    var a = seed >>> 0;
    return function () {
      a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function dayNumber() {
    // Gün numarası — aynı gün boyunca SABİT (yenilemede değişmez), ertesi gün değişir
    return Math.floor(Date.now() / 86400000);
  }
  function fmt(n) {
    try { return Number(n).toLocaleString('tr-TR'); } catch (e) { return String(n); }
  }

  /* ===================== Değer üretimi ===================== */
  function computeFor(id) {
    // 1) Ürüne özgü SABİT taban (güne bağlı değil) → kimlik/kalıp seçimi
    var base = mulberry32(hashStr('sp-base-' + id));
    var views0 = Math.floor(CFG.viewsMin + base() * (CFG.viewsMax - CFG.viewsMin));
    var ratio = CFG.addRatioMin + base() * (CFG.addRatioMax - CFG.addRatioMin);
    var tplIndex = Math.floor(base() * VIEW_TEMPLATES.length) % VIEW_TEMPLATES.length;

    // 2) Güne bağlı küçük dalgalanma (gün içinde sabit)
    var dayRnd = mulberry32(hashStr('sp-day-' + id + '-' + dayNumber()));
    var drift = 1 + (dayRnd() * 2 - 1) * CFG.dailyDriftPct;

    var views = Math.max(CFG.viewsMin, Math.round(views0 * drift));
    var adds = Math.max(CFG.addMin, Math.round(views * ratio));

    return { views: views, adds: adds, tplIndex: tplIndex };
  }

  var REDUCE_MOTION = (function () {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch (e) { return false; }
  })();

  /* ===================== Render + animasyon ===================== */
  function fill(el) {
    if (!el || el.getAttribute('data-sp-done') === '1') return;
    var id = el.getAttribute('data-sp-id');
    if (!id) return;
    var d = computeFor(id);
    var isCard = el.getAttribute('data-sp-ctx') === 'card' || !!el.closest('.grid-product');

    var viewStr, addStr;
    if (isCard) {
      viewStr = compactView(fmt(d.views));
      addStr = compactAdd(fmt(d.adds));
    } else {
      viewStr = VIEW_TEMPLATES[d.tplIndex](fmt(d.views));
      addStr = ADD_TEMPLATES[d.tplIndex](fmt(d.adds));
    }

    el.setAttribute('data-sp-done', '1');
    el.style.display = '';

    // Hareket azaltma tercihi: tek statik satır (döngü yok)
    if (REDUCE_MOTION) {
      el.textContent = viewStr + ' · ' + addStr;
      return;
    }

    // Animasyonlu tek satır: görüntülenme → sepete-eklendi → döngü
    var span = document.createElement('span');
    span.className = 'tsp-line';
    span.style.display = 'inline-block';
    span.style.transition = 'opacity ' + CFG.fadeMs + 'ms ease';
    span.style.opacity = '1';
    span.textContent = viewStr;
    el.textContent = '';
    el.appendChild(span);

    var states = [viewStr, addStr];
    var idx = 0;
    // Kartlar aynı anda çakmasın diye ürüne bağlı küçük başlangıç gecikmesi
    var startOffset = hashStr('sp-off-' + id) % 1500;

    function step() {
      span.style.opacity = '0';
      setTimeout(function () {
        idx = 1 - idx;
        span.textContent = states[idx];
        span.style.opacity = '1';
      }, CFG.fadeMs);
    }
    setTimeout(function () {
      var timer = setInterval(step, CFG.holdMs);
      // Eleman DOM'dan kalkarsa (AJAX filtre vs.) döngüyü durdur
      el._tspTimer = timer;
    }, startOffset);
  }

  function render(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll(CFG.selector);
    for (var i = 0; i < els.length; i++) fill(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { render(); });
  } else {
    render();
  }
  // Koleksiyon AJAX/filtre yüklemelerinden sonra yeni kartları da doldur
  window.addEventListener('load', function () { render(); });
  document.addEventListener('shopify:section:load', function (e) { render(e.target); });

  // Dış çağrı için (gerekirse)
  window.ToserofSocialProof = { render: render, computeFor: computeFor };
})();
